import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import AddAthleteForm from "./components/AddAthleteForm";
import RosterUpload from "./components/RosterUploadToDrive";
import Button from "../../components/Button";
import AthleteSignupLink from "./components/AthleteSignUpLink";
import AdminNavBar from "../admin/components/AdminNavBar";
import { useTranslation } from "../../i18n/TranslationProvider";

// Matches ADMIN_ROLES in routes/routes.js — kept in sync manually since
// this is a temporary, page-local check.
const ADMIN_ROLES = ["Administrator", "Athletic Director/Administrator"];

const AddNewAthletes = () => {
    const { userId, userProfile } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isAdmin = ADMIN_ROLES.includes(userProfile?.user_type);

    return (
        <> {isAdmin && (
                <AdminNavBar />
            )}
            {/* don't round the left corner if the admin navbar is displayed */}
            <div
                className={`custom-container mx-auto w-4/5 md:w-2/3 lg:w-1/2  ${
                    isAdmin ? "!rounded-tl-none" : "rounded-t-lg"
                }`}
            >
                <h4 className="text-lg md:text-2xl text-center mx-auto">
                    {t("athletes.addNewHeading")}
                </h4>
                <p className="text-center mb-6">
                    {t("athletes.addNewSubtext")}
                </p>
                <section>
                    <h6 className="text-xl mb-4">{t("athletes.uploadRosterSectionHeading")}</h6>
                    <RosterUpload />
                </section>
                {/* <h6 className="text-xl my-4">Athlete Signup Link </h6>
                <AthleteSignupLink /> */}
                <section className="flex items-center my-6">
                    <hr className="flex-grow border-t border-gray-300" />
                    <span className="px-4 text-gray-500">{t("common.or")}</span>
                    <hr className="flex-grow border-t border-gray-300" />
                </section>
                <section>
                    <h6 className="text-xl mb-4">{t("athletes.addManuallyHeading")}</h6>
                    <AddAthleteForm userId={userId} />
                </section>
                <Button
                    variant="outline"
                    className="mt-4"
                    onClick={() => navigate("/athletes")}
                >
                    {t("athletes.backToRoster")}
                </Button>
            
            </div>
        </>
    );
};

export default AddNewAthletes;